import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, FileText, GraduationCap, Phone, Info, DollarSign, BookOpen } from "lucide-react";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const navigationItems = [
  { title: "Home", url: "/", icon: Info, keywords: ["home", "main", "index"] },
  { title: "About", url: "/about", icon: Info, keywords: ["about", "history", "mission", "vision"] },
  { title: "Programs", url: "/programs", icon: GraduationCap, keywords: ["programs", "degrees", "courses", "study"] },
  { title: "Admissions", url: "/admissions", icon: FileText, keywords: ["admissions", "apply", "enroll", "requirements"] },
  { title: "Tuition", url: "/tuition", icon: DollarSign, keywords: ["tuition", "fees", "costs", "financial", "aid"] },
  { title: "Library", url: "/library", icon: BookOpen, keywords: ["library", "resources", "books", "research"] },
  { title: "Contact", url: "/contact", icon: Phone, keywords: ["contact", "email", "phone", "location"] },
];

export function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        onOpenChange(!open);
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [open, onOpenChange]);

  const handleSelect = (url: string) => {
    onOpenChange(false);
    navigate(url);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search pages..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigation">
          {navigationItems.map((item) => (
            <CommandItem
              key={item.url}
              value={`${item.title} ${item.keywords.join(" ")}`}
              onSelect={() => handleSelect(item.url)}
              className="cursor-pointer"
            >
              <item.icon className="mr-2 h-4 w-4" />
              <span>{item.title}</span>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
